module.exports = __webpack_public_path__ + "img/Samseir.cd6b7a6.png";